import React from 'react';
import { Box, Typography } from '@mui/material';
import AnimatedLogo from './AnimatedLogo';

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#f8fafc',
      }}
    >
      <AnimatedLogo size={120} color="#4890fe" />
      <Typography
        variant="h6"
        sx={{
          mt: 4,
          color: '#4A5568',
          fontWeight: 500,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen; 